export default __webpack_public_path__ + "assets/images/54ef03ba8dc87d42e129e3612e65f96e.jpeg";